import { FaDollarSign, FaGlobe, FaSignal, FaTools, FaWifi } from "react-icons/fa";
import images from "./images";

const About = {
  heading: "Le nostre radici affondano nel territorio",
  description: [
    "Blu Call è una compagnia telefonica con sede a Guagnano, in provincia di Lecce, fondata nel 2012 dalla famiglia Monte. L’azienda nasce come WISP (Wireless Internet Service Provider), con l’obiettivo di portare connettività a banda larga nel territorio del Nord Salento, inizialmente attraverso tecnologie wireless.\n" +
    "Negli anni, grazie a una visione imprenditoriale solida e alla fiducia guadagnata sul campo, Blu Call ha saputo evolversi fino a diventare un operatore di riferimento nel settore delle telecomunicazioni regionali. Da operatore WISP, l’azienda è cresciuta fino a diventare wholesale partner di Telecom Italia (oggi FiberCop), ampliando la propria offerta con soluzioni su rete FTTC (Fiber To The Cabinet) e FTTH (Fiber To The Home), oltre a mantenere l’operatività FWA (Fixed Wireless Access) nelle aree meno coperte.\n" +
    "Attualmente Blu Call opera anche su rete ULL (Unbundling Local Loop) Fastweb, offrendo così una maggiore indipendenza infrastrutturale e una copertura più ampia. L’azienda si distingue per l’installazione di prodotti certificati e di alta qualità, garantendo affidabilità, performance e assistenza tecnica puntuale.\n" +
    "Oltre ai servizi residenziali, Blu Call fornisce soluzioni avanzate per le imprese, tra cui collegamenti punto-punto per grandi aziende, centrali IVR (Interactive Voice Response), connettività dedicata e personalizzabile, servizi di fonia professionale e supporto tecnico dedicato.\n" +
    "Grazie all’impegno della famiglia Monte e del suo team, Blu Call continua a investire nel territorio e nelle tecnologie più moderne, con l’obiettivo di offrire connettività veloce, stabile e su misura per ogni esigenza.",
  ],
  experience: {
    icon: <FaGlobe />,
    year: "10+ anni",
    text: "di esperienza nel settore",
  },
  points: [

  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    alt1: "About-Image-1",
    alt2: "About-Image-2",
  },
  button: {
    text: "Galleria",
    link: "Gallery",
  },
};

export default About;